import { useState } from "react";
import { SearchBar } from "../../components/SearchBar";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyAdmin } from "./VerifyAdmin";
import { useUtility } from "../../contexts/auth/UtilityContext";
import { SchoolRow } from "../../components/SchoolRow";

export function Schools() {
    const [searchValue, setSearchValue] = useState<string>("");
    const { schools } = useUtility();
    
    return(
        <LoggedInLayoutSelector>
            <VerifyAdmin />
            <div className='main-bg min-h-[90vh] flex flex-row'>
                <div className='flex h-full w-[80%] mx-[10%]'>
                    <h1 className="text-2xl font-bold">Pending Requests</h1>
                    <div className="flex flex-row w-full">
                        <div className="flex flex-col rounded-lg border-solid border-2 my-2 p-2 mx-6 border-gray-300 w-[280px] h-[500px]">
                            <SearchBar setSearchValue={setSearchValue} />
                        </div>
                        <div className="overflow-visible w-[80%]">
                            {schools.filter(school => school.FullName.includes(searchValue)).map((school, index) => <SchoolRow key={index} {...school} />)}
                            {schools.length === 0 && <div className="text-center">No schools found</div>}
                        </div>
                    </div>
                </div>
            </div>
        </LoggedInLayoutSelector>
    )
}